import { formatCurrencyBR } from "../../../../utils/formatUtils";
import { centavosToReais } from "../../../../utils/currencyMaskBank";

export const CAIXA_CLINICA_DEFAULT = "CAIXA CLINICA";
export const ID_CAIXA_ABERTO = "__caixa_operacional_aberto__";
export const ID_CAIXA_FECHADO = "__caixa_operacional_fechado__";

export function isContaCaixa(conta) {
  return /^0{1,3}$/.test(String(conta?.banco ?? "").trim());
}

export function getContaDisplayName(conta) {
  const nome = (conta?.nome || "").trim();
  return nome || CAIXA_CLINICA_DEFAULT;
}

/** Valor bruto do saldo da conta (API / persistência em centavos no fluxo financeiro). */
export function getSaldoContaRaw(conta) {
  const n = Number(conta?.saldoAtual ?? conta?.saldoInicial ?? 0);
  return Number.isFinite(n) ? n : 0;
}

/** Saldo em reais para cálculos no modal. */
export function getSaldoContaReais(conta) {
  return centavosToReais(getSaldoContaRaw(conta));
}

/** Ex.: "260 - Conta Corrente Bradesco" */
export function getContaBancoLinha(conta) {
  const cod = conta?.banco != null ? String(conta.banco).trim() : "";
  const nome = (conta?.nome || "").trim();
  if (cod && nome) return `${cod} - ${nome}`;
  if (cod) return cod;
  return nome || getContaDisplayName(conta);
}

/** Formata saldo armazenado em centavos para exibição BRL. */
export function formatSaldoExibicao(valorCentavos) {
  const fmt = formatCurrencyBR(valorCentavos ?? 0, true);
  return fmt === "-" ? "R$ 0,00" : fmt;
}

export function resolveContaOperacional(contas) {
  return (contas || []).find((c) => c.ativa !== false && isContaCaixa(c)) || null;
}

/** Apenas contas cadastradas na instituição 000 podem representar o caixa. */
export function buildOpcaoCaixa(contas, caixaAberto) {
  const resolved = resolveContaOperacional(contas);
  return resolved ? { ...resolved, isOpcaoCaixaOperacional: true, caixaAberto } : null;
}

/** @deprecated Use buildOpcaoCaixa — mantido para compatibilidade. */
export function buildOpcaoCaixaAberto(contas, caixaAberto) {
  if (!caixaAberto) return null;
  return buildOpcaoCaixa(contas, true);
}

export function isSelecaoCaixaOperacional(contaId, opcaoCaixa) {
  if (!contaId || !opcaoCaixa) return false;
  return String(contaId) === String(opcaoCaixa._id);
}

export function isIdCaixaOperacionalVirtual(contaId) {
  const id = String(contaId || "");
  return id === ID_CAIXA_ABERTO || id === ID_CAIXA_FECHADO;
}

/** ID da conta bancária usada na API ao selecionar o caixa operacional virtual. */
export function resolveContaDestinoReforco(contaId, contas) {
  const conta = (contas || []).find((c) => c.ativa !== false && isContaCaixa(c) && String(c._id) === String(contaId));
  return conta?._id || null;
}

/** Primeira conta bancária (fora do caixa operacional) para pré-seleção com caixa fechado. */
export function getPrimeiraContaBancaria(contas, opcaoCaixa) {
  const { outras } = partitionContas(contas, opcaoCaixa);
  return outras[0] || null;
}

export function partitionContas(contas, opcaoCaixa) {
  const caixas = (contas || []).filter((c) => c.ativa !== false && isContaCaixa(c));
  return { caixas, caixaOperacional: caixas.find((c) => String(c._id) === String(opcaoCaixa?._id)) || caixas[0] || null, outras: [] };
}
